<template>
    <div class="box">
        <div class="box-left">
            <my-form
                v-model="form"
                autocomplete="off"
                label-width="80px"
                @submit="submitHandler"
            >
                <el-form-item
                    label="总概算"
                    prop="costlimit"
                    :rules="newRule('总概算', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.costlimit"
                        oninput="value=value.replace(/[^0-9.]/g,'')"
                        clearable
                        autocomplete="off"
                        :placeholder="`请输入总概算`"
                    >
                        <template slot="append">万元</template>
                    </el-input>
                </el-form-item>

                <el-form-item
                    label="折扣"
                    prop="discount"
                    :rules="newRule('折扣', 'required')"
                >
                    <el-input
                        class="login-input"
                        v-model="form.discount"
                        @change="discountHandler"
                        clearable
                        type="number"
                        min="0"
                        autocomplete="off"
                        :placeholder="`请输入折扣`"
                    >
                        <template slot="append">%</template>
                    </el-input>
                </el-form-item>

                <template slot="btn" slot-scope="scope">
                  <div class="btn-login">
                    <el-button
                      type="primary"
                      @click="scope.submitHandler"
                    >
                      开始计算
                    </el-button>
                  </div>
                </template>
            </my-form>
        </div>

        <div class="box-right">
          <div class="computed-result">
            <div>折扣后建设管理费：<span>{{discountCost}}</span> 万元</div>
            <div>标准建设管理费：<span>{{standardCost}}</span> 万元</div>
          </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                costlimit: "", //总概算
                discount: 100, //折扣
            },
            discountCost: "0", //折扣后费用
            standardCost: "0", //标准费用
            options: [],


        };
    },
    methods: {
        /**
         *
         */
        submitHandler() {
            this.$get(`${this.$store.state.api.webUrl}/navigation/getCalculateData.json`,{
                costlimit:this.form.costlimit,
                discount:this.form.discount,
                type:"TYPE5"
            },data => {
                    this.discountCost = data.discount
                    this.standardCost = data.standard
            });
            this.$emit('startCompute');
        },
        /**
         * 折扣输入框 change 事件
         */
        discountHandler(){
            if(this.form.discount < 0){
                this.form.discount = 0
            }
          let discountStr = String(this.form.discount)
          discountStr = discountStr.replace(/[^\d.]/g, "")
            .replace(/^0\d+|^\./g, "")
            .replace(/\.{2,}/g, ".")
            .replace(".", "$#$")
            .replace(/\./g, "")
            .replace("$#$", ".")
            .replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
          this.form.discount = parseFloat(discountStr) || 0;
        },

    },
    mounted () {

    },
};
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    box-sizing: border-box;
    .coefficient {
        display: block;
        margin-top: -6px;
        margin-left: 80px;
        margin-bottom: 24px;
        color: #606266;
    }
    .select {
        width: 100%;
    }

    .btn-login {
      display: flex;
      justify-content: center;
    }
}
.box > div {
    float: left;
    width: 400px;
}

.box-right {
    margin-top: 0;
    margin-left: 100px;
    width: 520px !important;
    p{
        margin-bottom: 24px;
    }
}

.computed-result{
  margin-top: -55px;
  font-size: 17px;
  font-weight: 600;
  color: #606266;
  div{
    margin-bottom: 15px;
  }
  span{
    color: red;
  }
}
</style>
